<script setup lang="ts">

import { ref } from 'vue';

const isModalOpen = ref(false);

const openModal = () => {
    isModalOpen.value = true;
};

const closeModal = () => {
    isModalOpen.value = false;
};

const runtimeConfig = useRuntimeConfig();

</script>

<template>
  <footer aria-label="social links"
          class="container-footer mx-auto">
    <div class="display-flex align-items-center width-full flex-col-reverse-bp-768 align-items-start-bp-768 gap-16-bp-768 justify-between footer-border mx-auto footer-contain">
      <p class="display-500-accent footer-author">
        © {{ runtimeConfig.public.footer.copyright }}
      </p>

      <div class="display-flex flex-col-bp-576 width-full-bp-576">
        <Button size="size.medium"
                color="bg.mojito"
                class="width-full-bp-576"
        >
          <button type="button"
                  @click="openModal"
          >
            <span class="compact-500-accent">Newsletter</span>
          </button>
        </Button>
        <Button size="size.medium"
                color="bg.text"
                class="width-full-bp-576 footer-btn-text justify-start"
        >
          <NuxtLink class="compact-500-accent"
                    to="/docs">
            Documents
          </NuxtLink>
        </Button>
      </div>

      <div class="display-flex align-items-center gap-4">
        <a class="display-flex align-items-center justify-center footer-link"
           :href="runtimeConfig.public.links.twitter"
           target="_blank"
           aria-label="Visit our page in Twitter"

        >
          <IconMain icon="twitter"
                    :size="24"
                    aria-hidden="true"
          />
          <span class="visually-hidden">Twitter</span>
        </a>
        <a class="display-flex align-items-center justify-center footer-link"
           :href="runtimeConfig.public.links.discord"
           target="_blank"
           aria-label="Join our server in Discord"

        >
          <IconMain icon="discord"
                    :size="24"
                    aria-hidden="true"

          />
          <span class="visually-hidden">Discord</span>
        </a>
      </div>
    </div>
  </footer>

  <Modal :model-value="isModalOpen"
         :width-content="660"

         @update:model-value="isModalOpen = $event"
  >
    <ModalNewsletter @closeModal="closeModal" />
  </Modal>
</template>

<style lang="scss" scoped>

.footer {
  &-btn {
    &-text {
      @include tablet-768 {
        a {
          padding-left: 0;
        }
      }
    }
  }

  &-contain {
    @include tablet-768 {
      flex-direction: column;

      :nth-child(1) {
        order: 3;
      }

      :nth-child(2) {
        order: 1;
      }

      :nth-child(3) {
        order: 2;
      }
    }
  }
}

.footer-border {
  padding: 40px 16px;
  border-top: 1px solid var(--border-primary);
}

.footer-author {
  color: var(--content-secondary);
  font-feature-settings: 'ss04' on, 'ss03' on, 'ss02' on;
}

.footer-link {
  min-width: var(--control-500-size-single, 52px);
  height: var(--control-500-size-single, 52px);
  transition: opacity 0.3s ease;
  border-radius: var(--control-500-radius, 2px);
  background: var(--bg-secondary);

  &:hover {
    opacity: 0.4;
  }

  svg {
    width: 24px;
    height: 24px;
  }

  @include tablet-768 {
    min-width: var(--control-400-size-single, 36px);
    height: var(--control-400-size-single, 36px);
  }

  @include mobile-576 {
    min-width: var(--control-500-size-single, 52px);
    height: var(--control-500-size-single, 52px);
  }
}

.footer-link-none {
  display: none;

  @include mobile-576 {
    display: flex;
  }
}

</style>
